<template>
    <v-touch @swiperight="swiperright" class="wrapper">
        <div class="contractProgress">
            <van-nav-bar
                title="合同进度"
                left-text="应用"
                left-arrow
                @click-left="onClickLeft"
            >
            </van-nav-bar>
            <section>
                <van-search v-model="SearchValue" placeholder="请输入搜索信息" @change="SearchChange"></van-search>
                <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
                    <van-list
                        v-model="isUpLoading"
                        :finished="finished"
                        finished-text="没有更多了!"
                        @load="onLoad"
                    >
                        <ul class="commonTableStyles list">
                            <template>
                                <li v-for="(item,index) in listData" :key="index" :class="`item-${item.contract_type}`">
                                    <div class="engineeringInfo">
                                        <h4 class="engineeringInfo_header">
                                            <span class="headerName">合同编号：{{ item.contract_number }}</span>
                                        </h4>
                                        <span class="state iconfont iconjiaobiao"><i>{{ item.contract_type | contractType }}</i></span>
                                        <div class="engineeringInfo_content">
                                            <p>
                                                <img src="@/assets/images/icons/icon_gy_3.png" alt="">
                                                <span>客户名称：{{ item.client_name }}</span>
                                            </p>
                                            <p>
                                                <img src="@/assets/images/icons/icon_gy_3.png" alt="">
                                                <span>项目名称：{{ item.engineering_name }}</span>
                                            </p>
                                            <p>
                                                <img src="@/assets/images/icons/icon_gy_7.png" alt="">
                                                <span>签订日期：{{ item.signing_date }}</span>
                                            </p>
                                        </div>
                                        <van-divider dashed></van-divider>
                                    </div>
                                    <div class="charts">
                                        <div class="chart">
                                            <van-circle
                                                class="van_left"
                                                v-model="item.currentRate"
                                                :rate="capacityRate(item)"
                                                :size="40"
                                                :speed="100"
                                                :text="capacityText(item)"
                                                color="#3495FB"
                                                layer-color="#d5e9fe"
                                                :stroke-width="100"
                                            ></van-circle>
                                            <div class="van_left legend estimate">
                                                <p>
                                                    预计方量:
                                                    <span>{{ item.projected_capacity }}m³</span>
                                                </p>
                                                <p>
                                                    已发方量:
                                                    <span>{{ item.delivery_total_quantity }}m³</span>
                                                </p>
                                            </div>
                                        </div>
                                        <div class="chart">
                                            <van-circle
                                                class="van_left"
                                                v-model="item.currentRate2"
                                                :rate="amountRate(item)"
                                                :size="40"
                                                :speed="100"
                                                :text="amountText(item)"
                                                text-color="#F15742"
                                                color="#F15742"
                                                layer-color="rgba(255, 225, 225, 1)"
                                                :stroke-width="100"
                                            ></van-circle>
                                            <div class="van_left legend receivables">
                                                <p>
                                                    应收款:
                                                    <span>{{ item.sales_amount1 }}万</span>
                                                </p>
                                                <p>
                                                    已回款:
                                                    <span>{{ item.aggregate_official_receipt1 }}万</span>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </li>
                            </template>
                        </ul>
                    </van-list>
                </van-pull-refresh>
            </section>
        </div>
    </v-touch>
</template>
<script>
export default {
    // 合同进度
    name: 'contract-progress',
    beforeRouteLeave(to, from, next) {
        if (to.path === '/home') {
            this.keywords = '';
            this.$store.commit('noKeepAlive', 'contract-progress');
        }
        next();
    },
    components: {},
    props: {},
    data() {
        return {
            SearchValue: '',
            // 下拉login状态
            isLoading: false,
            // 上拉login状态
            isUpLoading: false,
            // 是否已加载完所有数据
            finished: false,
            // 分页
            page: {
                pageindex: 1,
                pagesize: 10,
            },
            // 列表数据
            listData: [],
            // 列表总条数
            total: 0,
            // 记录上拉还是下拉
            slidingDirection: '',
            // 是否是领导端
            isLeader: false,
        };
    },
    filters: {
        contractType(type) {
            const arr = {
                '102-LS1': '临时',
                '102-LS2': '零售',
                '102-XX0': '现销',
                '102-ZS0': '正式',
            };
            return arr[type];
        },
    },
    computed: {

    },
    watch: {},
    created() {
        // 是否是领导端
        this.isLeader = this.$route.query.leader;
    },
    mounted() {
    },
    destroyed() {},
    methods: {
        // 方量比例文字
        capacityText(item) {
            if (item.delivery_total_quantity === 0 || item.projected_capacity === 0) {
                return 0 + '%';
            }
            return Math.floor(item.delivery_total_quantity / item.projected_capacity * 100) + '%';
        },
        // 方量比例值
        capacityRate(item) {
            if (item.delivery_total_quantity === 0 || item.projected_capacity === 0) {
                return 0;
            }
            return Math.floor(item.delivery_total_quantity / item.projected_capacity * 100);
        },
        // 费用比例文字
        amountText(item) {
            if (item.sales_amount === 0 || item.aggregate_official_receipt === 0) {
                return 0 + '%';
            }
            return Math.floor(item.aggregate_official_receipt / item.sales_amount * 100) + '%';
        },
        // 费用比例值
        amountRate(item) {
            if (item.sales_amount === 0 || item.aggregate_official_receipt === 0) {
                return 0;
            }
            return Math.floor(item.aggregate_official_receipt / item.sales_amount * 100);
        },
        getInit() {
            let url = '';
            if (this.isLeader) {
                url = 'get_clients_leader_page';
            } else {
                url = 'get_clients_page';
            }
            // 获取合同列表
            this.$axios
                .get(`/interfaceApi/sale/contract_progress/${url}?pageindex=`
                 + this.page.pageindex + '&pagesize='
                 + this.page.pagesize + '&Keywords='
                 + this.SearchValue)
                .then(res => {
                    this.total = res.total;
                    res.rows = res.rows.map(item => {
                        if (item.sales_amount || item.sales_amount === 0) {
                            item.sales_amount1 = (Number(item.sales_amount) / 10000).toFixed(2);
                        }
                        if (item.aggregate_official_receipt || item.aggregate_official_receipt === 0) {
                            item.aggregate_official_receipt1 = (Number(item.aggregate_official_receipt) / 10000).toFixed(2);
                        }
                        return item;
                    });
                    if (this.listData.length < 1 || this.slidingDirection === 'down') {
                        this.listData = res.rows;
                        this.finished = false;
                    } else {
                        res.rows.forEach(item => {
                            this.listData.push(item);
                        });
                    }
                    if (this.listData.length === this.total) {
                        this.finished = true;
                    }
                    this.isLoading = false;
                    this.isUpLoading = false;
                })
                .catch(error => {
                    this.$dialog({ message: error.ErrorCode.Message });
                });
        },
        // 返回上一页
        onClickLeft() {
            this.$router.isBack = 1;
            this.$router.push({ path: '/home' });
        },
        // 右划回退
        swiperright() {
            this.$router.isBack = 1;
            this.$router.push({ path: '/home' });
        },
        // 下拉刷新
        onRefresh() {
            this.slidingDirection = 'down';
            this.page.pageindex = 1;
            this.getInit();
            this.page.pageindex++;
        },
        // 上拉加载更多
        onLoad() {
            this.slidingDirection = 'up';
            this.getInit();
            this.page.pageindex++;
        },
        // 搜索
        SearchChange() {
            this.slidingDirection = 'down';
            this.page.pageindex = 1;
            this.getInit();
            this.page.pageindex++;
        },
    },
};
</script>
<style lang="stylus" scoped>
.contractProgress
    height 100%
    background #F0F0F0
    section
        height calc(100% - 45rpx)
        .van-pull-refresh
            height calc(100% - 45rpx)
            overflow: scroll;
            -webkit-overflow-scrolling: touch;
            .list
                background #F0F0F0
                padding 15rpx
                padding-bottom 0
                li
                    width 100%
                    background #fff
                    margin-bottom 15rpx
                    .engineeringInfo
                        .engineeringInfo_content
                            margin-bottom: 0
                    .btns
                        padding 0 6rpx
                        text-align center
                        div
                            border 1px solid #D7D7D7
                            border-radius 4rpx
                            background #fff
                            height 32rpx
                            line-height 32rpx
                            text-align center
                            display inline-block
                            margin 0 25rpx
                            font-size 14rpx
                            color #333333
                            width calc((100% - 36rpx)/3)
                            img
                                width 16rpx
                                vertical-align middle
                                margin-top -4rpx
                    &.item-102-LS1
                        h4
                            span
                                &:before
                                    color #191990
                        .state
                            &:before
                                color #191990
                    &.item-102-LS2
                        h4
                            span
                                &:before
                                    color #FF6600
                        .state
                            &:before
                                color #FF6600
                    &.item-102-XX0
                        h4
                            span
                                &:before
                                    color #00A84B
                        .state
                            &:before
                                color #00A84B
                    &.item-102-ZS0
                        h4
                            span
                                &:before
                                    color #E60000
                        .state
                            &:before
                                color #E60000
                    .charts
                        height 80rpx
                        position relative
                        padding-left 10rpx
                        &:after
                            content ''
                            position absolute
                            width 1px
                            height 15rpx
                            background #F0F0F0
                            left 50%
                            top 50%
                            margin-top -7rpx
                        .chart
                            float left
                            height 100%
                            width 50%
                            padding-bottom 15rpx
                            .van-circle
                                margin-top 6rpx
                        .legend
                            width calc(100% - 50rpx)
                            padding-left 4rpx
                            p
                                font-size 10rpx
                                line-height 24rpx
                            &.estimate
                                span
                                    color #3495FB
                            &.receivables
                                span
                                    color #F15742
</style>
